import Globalnav from '@99designs/globalnav';
import initContainer from '@99designs/brand-container/index';
import relativeTime from '@99designs/brand-container/lib/ui/relative-time';
import { loadIntlDataForLocale, loadGlobalNavIntlDataForLocale } from 'common/utils/intl';

export default function initialise() {
    return new Promise((resolve, reject) => {
        if (!document.querySelector('[data-globalnavui]')) {
            return resolve();
        }

        const locale = document.documentElement.getAttribute('data-locale');

        initContainer();
        relativeTime.attachTo('html');

        const appNode = document.querySelector('[data-globalnav-notifications-dropdown]');

        // appNode only present for logged in users
        if (appNode) {
            loadIntlDataForLocale(locale)
                .then(() => loadGlobalNavIntlDataForLocale(locale))
                .then(() => {
                    Globalnav(appNode, locale);
                    resolve();
                })
        } else {
            resolve();
        }
    });
}



// WEBPACK FOOTER //
// ./js/common/components/globalNav.js